import { render } from "./ThePanelMenu.vue?vue&type=template&id=87313a06"
import script from "./ThePanelMenu.vue?vue&type=script&lang=js"
export * from "./ThePanelMenu.vue?vue&type=script&lang=js"
script.render = render

export default script